exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".VFya8YglGblks-W91w8aU{font-size:12px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;white-space:pre-wrap}", ""]);
// Exports
exports.locals = {
	"container": "VFya8YglGblks-W91w8aU"
};